import TopBanner from '../Slices/TopBanner';
import HolidayOffers from 'containers/Slices/HolidayOffers';

export const seriesLandingSlices = (block, type, index) => {
  switch (type) {
    case 'top_banner':
      return <TopBanner block={block} key={`${type}-${index}`} />;
    case 'holiday_offers':
      return <HolidayOffers block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};
